import React from 'react';
import ErrorScreen from './ErrorScreen';

/**
 * Captura errores de render de React no controlados (la causa real de las
 * "pantallas en blanco") y muestra una ErrorScreen con salidas en lugar de
 * dejar la app rota. Es un class component porque los error boundaries solo
 * pueden implementarse con la API de clases.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturó un error:', error, info);
    // Telemetría propia: reporta el error al backend para que el equipo se
    // entere sin depender de que el usuario lo comunique. Fire-and-forget:
    // si el reporte falla, no debe agravar el error original.
    try {
      const backend = process.env.REACT_APP_BACKEND_URL;
      if (backend) {
        fetch(`${backend}/api/telemetry/error`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: String(error?.message || error).slice(0, 500),
            stack: String(error?.stack || '').slice(0, 4000),
            component_stack: String(info?.componentStack || '').slice(0, 2000),
            url: window.location.href.slice(0, 500),
          }),
        }).catch(() => {});
      }
    } catch (_) { /* nunca propagar errores del reporte */ }
  }

  handleRetry = () => {
    // Reintenta el render limpiando el estado; si persiste, recarga.
    this.setState({ hasError: false });
  };

  handleBack = () => {
    this.setState({ hasError: false });
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.assign((process.env.PUBLIC_URL || '') + '/');
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen
          onRetry={() => window.location.reload()}
          onBack={this.handleBack}
        />
      );
    }
    return this.props.children;
  }
}
